var _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadedDocument = function SvgUploadedDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 105 119"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#uploadedDocument_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9FBFF",
    d: "M13 9.054C13 7.919 13.92 7 15.054 7h54.42l22.124 27.154c.3.368.464.83.462 1.304l-.234 62.934a2.054 2.054 0 0 1-2.054 2.046H15.054A2.054 2.054 0 0 1 13 98.384z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#uploadedDocument_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m69.474 7 22.589 27.723H71.527a2.054 2.054 0 0 1-2.053-2.053z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.677,
    height: 0.473,
    x: 24.393,
    y: 18.954,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.677,
    height: 0.473,
    x: 31.963,
    y: 27.47,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.731,
    height: 0.473,
    x: 24.393,
    y: 22.739,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.258,
    height: 0.473,
    x: 24.393,
    y: 23.212,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-90 24.393 23.212)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 0.473,
    x: 31.963,
    y: 26.051,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-90 31.963 26.051)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.097,
    height: 0.473,
    x: 45.743,
    y: 28.154,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-121.945 45.743 28.154)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.625,
    height: 0.473,
    x: 39.924,
    y: 24.423,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-46.838 39.924 24.423)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.785,
    height: 0.473,
    x: 40.006,
    y: 22.739,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-90 40.006 22.74)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.785,
    height: 0.473,
    x: 40.006,
    y: 27.944,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-90 40.006 27.944)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.312,
    height: 0.473,
    x: 24.393,
    y: 27.944,
    fill: "#D9D9D9",
    stroke: "#427CFF",
    strokeLinejoin: "round",
    strokeWidth: 0.473,
    rx: 0.237,
    transform: "rotate(-90 24.393 27.944)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "uploadedDocument_svg__a",
    width: 103.215,
    height: 117.592,
    x: 0.923,
    y: 1.279,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.356
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.038
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1615_18804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1615_18804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "uploadedDocument_svg__b",
    width: 39.13,
    height: 44.263,
    x: 59.204,
    y: 0.73,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1615_18804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1615_18804",
    result: "shape"
  })))));
};
export { SvgUploadedDocument as ReactComponent };